import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = { start: number; end: number };

export const useDefaultObservableStartNumberEndNumber = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectStartNumberEndNumber extends BehaviorSubject<CurrentType> {}
